var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Box, Typography, Popover, Button, Link } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
export var DataSourceTooltip = function (_a) {
    var base = _a.base, description = _a.description, link = _a.link;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    return (_jsxs(Box, { children: [_jsx(Button, __assign({ variant: "outlined", size: "small", startIcon: _jsx(InfoOutlinedIcon, { sx: { fontSize: "1.1rem !important" } }), onClick: handleOpen, onMouseEnter: handleOpen, sx: {
                    textTransform: "none",
                    fontFamily: "Montserrat, sans-serif",
                    fontSize: "0.82rem",
                    fontWeight: 600,
                    color: "#4B5563",
                    borderColor: "#E5E7EB",
                    borderRadius: "8px",
                    px: 1.5,
                    py: 0.5,
                    "&:hover": {
                        borderColor: "#034EA2",
                        color: "#034EA2",
                        backgroundColor: "rgba(3, 78, 162, 0.04)",
                    },
                } }, { children: "Fonte dos dados" })), _jsxs(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, slotProps: {
                    paper: {
                        onMouseLeave: handleClose,
                        sx: {
                            mt: 1,
                            p: 2.5,
                            width: 320,
                            borderRadius: "12px",
                            boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -2px rgba(0,0,0,0.05)",
                            border: "1px solid #E5E7EB",
                        },
                    },
                } }, { children: [_jsx(Typography, __assign({ sx: {
                            fontFamily: "Montserrat, sans-serif",
                            fontSize: "0.9rem",
                            fontWeight: 700,
                            color: "#111827",
                            mb: 2,
                        } }, { children: "Fonte dos dados" })), _jsxs(Box, __assign({ sx: { mb: 2 } }, { children: [_jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    color: "#6B7280",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.025em",
                                    mb: 0.5,
                                } }, { children: "Base:" })), _jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.85rem",
                                    color: "#374151",
                                    lineHeight: 1.5,
                                } }, { children: base }))] })), description && (_jsx(Box, __assign({ sx: { mb: 2 } }, { children: _jsx(Typography, __assign({ sx: {
                                fontFamily: "Montserrat, sans-serif",
                                fontSize: "0.85rem",
                                color: "#4B5563",
                                lineHeight: 1.5,
                            } }, { children: description })) }))), _jsxs(Box, { children: [_jsx(Typography, __assign({ sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    color: "#6B7280",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.025em",
                                    mb: 0.5,
                                } }, { children: "Link:" })), _jsx(Link, __assign({ href: link, target: "_blank", rel: "noreferrer", sx: {
                                    fontFamily: "Montserrat, sans-serif",
                                    fontSize: "0.85rem",
                                    color: "#034EA2",
                                    textDecoration: "underline",
                                    wordBreak: "break-all",
                                    lineHeight: 1.5,
                                    display: "block",
                                } }, { children: link }))] })] }))] }));
};
